import { runImpactCalculateCo2ForProject } from '@/domain/impact-calculate/actions/run-impact-calculate-co2-for-project.action';
import { getImpactCo2AnswersForCategory } from '@/domain/impact-co2/actions/get-impact-co2-answers-for-category.action';
import { ImpactCo2Answer } from '@/domain/impact-co2/entities/question.entity';
import { SnackbarGateway } from '@/domain/snackbar/gateways/snackbar.gateway';
import { createAppAsyncThunk } from '@/domain/store.thunk';
import { translate } from '@/ui/i18n';

type Params = {
  projectId: number;
  answer: ImpactCo2Answer;
  recalculateAfterSubmit?: boolean;
};

export const deleteImpactCo2Answer = createAppAsyncThunk(
  'impactCo2/deleteImpactCo2Answer',
  async (
    { projectId, answer, recalculateAfterSubmit = true }: Params,
    { extra: { impactCo2Gateway, snackbarGateway }, dispatch },
  ): Promise<void> => {
    try {
      await impactCo2Gateway.deleteImpactAnswer(answer);
      showSnackbarSuccess(snackbarGateway);
      dispatch(
        getImpactCo2AnswersForCategory({
          projectId,
          category: answer.category,
        }),
      );
      if (recalculateAfterSubmit) {
        dispatch(runImpactCalculateCo2ForProject({ projectId }));
      }
    } catch (error) {
      showSnackbarError(snackbarGateway);
      throw error;
    }
  },
);

function showSnackbarSuccess(snackbarGateway: SnackbarGateway) {
  snackbarGateway.success(translate('DeleteImpactCo2Answer.Message.success'));
}

function showSnackbarError(snackbarGateway: SnackbarGateway) {
  snackbarGateway.error(translate('DeleteImpactCo2Answer.Message.error'));
}
